import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import RelativeTime from 'dayjs/plugin/relativeTime'
import { useTranslation } from 'react-i18next'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
dayjs.extend(RelativeTime)

interface Props {
  time?: string | number | null
  colorNever?: boolean
  neverText?: string
  className?: string
  markOutdatedDays?: number | null
  withTooltip?: boolean
}

const Timestamp = ({
  time,
  colorNever,
  neverText,
  className,
  markOutdatedDays,
  withTooltip,
}: Props) => {
  const { t } = useTranslation()
  const [timestampKey, setTimestampKey] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setTimestampKey((prev) => prev + 1)
    }, 60 * 1000)

    return () => clearInterval(interval)
  }, [])

  const content = time ? (
    <span key={timestampKey} className={className}>
      <span
        className={`${
          markOutdatedDays === null
            ? ''
            : dayjs(time).isBefore(
                dayjs().subtract(markOutdatedDays ?? 1, 'day'),
              )
            ? `text-warning-foreground`
            : 'text-success-foreground'
        }`}
      >
        {dayjs(time).fromNow()}
      </span>
    </span>
  ) : (
    <strong
      key={timestampKey}
      className={`${className} ${
        colorNever
          ? 'text-destructive-foreground'
          : 'font-normal italic opacity-70'
      }`}
    >
      {neverText || t('shared.never').toLowerCase()}
    </strong>
  )

  return withTooltip ? (
    <Tooltip>
      <TooltipTrigger asChild>{content}</TooltipTrigger>
      <TooltipContent>{dayjs(time).format('D MMM YYYY, HH:mm')}</TooltipContent>
    </Tooltip>
  ) : (
    content
  )
}

export default Timestamp
